import styled from 'styled-components';
import TriangleWhite from '../../../../containers/assets/bordered-triangle-left-white.svg';
import TriangleYellow from '../../../../containers/assets/bordered-triangle-left-yellow.svg';

export const Wrapper = styled.div`
  background: #f5f6f7;
  padding: 40px;
  flex: 1;
`;

export const PreTitle = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
  margin-bottom: 24px;
`;

export const Title = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
`;

export const Text = styled.div`
  margin-top: 12px;
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);

  b {
    color: #EC5E59;
  }

  strong {
    font-weight: 700;
    color: rgba(0, 27, 59, 1);
  }

  a:active, a:visited, a:link {
    color: #97b8f6;
    text-decoration: underline;
  }

  a:hover {
    text-decoration: none;
  }

  ul {
    list-style-type: disc;
    margin-left: 20px;
    margin-top: 10px;
  }

  ul li {
    font-size: 16px !important;
  }

  p {
    margin-bottom: 8px;
  }

  p:last-child {
    margin-bottom: 0;
  }

  span {
    color: rgba(0, 27, 59, 0.9);
    text-decoration: underline;
  }
`;

export const Image = styled.img`
  width: 100%;
`;

export const ContentContainer = styled.div`
  margin-top: 24px;
  background: #FFFFFF;
  border: 1px solid rgba(0, 27, 59, 0.15);
  border-radius: 8px;
  padding: 20px;
  font-family: 'Mukta Vaani';
  position: relative;

  ${p => p.transparent && `
    background: transparent;
    border: none;
    padding: 0;
  `}

  ${p => p.maxHeight && `
    max-height: ${p.maxHeight};
    overflow-y: auto;
  `}

  &::-webkit-scrollbar {
    width: 3px;
  }
   
  &::-webkit-scrollbar-thumb {
    background: #CCCCCC; 
  }

  .scatter-chart-container .recharts-wrapper .recharts-cartesian-grid-horizontal line:first-child,
  .scatter-chart-container .recharts-wrapper .recharts-cartesian-grid-horizontal line:last-child,
  .scatter-chart-container .recharts-wrapper .recharts-cartesian-grid-vertical line:first-child,
  .scatter-chart-container .recharts-wrapper .recharts-cartesian-grid-vertical line:last-child {
    stroke-opacity: 0;
  }
`;

export const ContentTitle = styled.h3`
  font-weight: 500;
  font-size: 11.5px;
  line-height: 13px;
  letter-spacing: 1px;
  color: rgba(0, 27, 59, 0.38);
  margin-bottom: 16px;

  ${p => p.big && `
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
    color: rgba(0, 27, 59, 0.6);
  `}
`;

export const ContentFlexColumns = styled.div`
  display: flex;
  align-items: center;
  
  ${p => p.withFloatinDetailsBlock && `
    width: calc(61% + 8px);
  `}
  
  ${p => p.withPadding && `
    padding-right: 15px;
  `}
`;

export const ContentRightColumn = styled.div`
  margin-left: 25px;
`;

export const ChartDataLabel = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #2F4166;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  cursor: pointer;

  ${p => p.disabled && `
    pointer-events: none;
  `}

  &:before {
    content: '';
    display: block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    margin-right: 8px;
    background-color: #81c991;
  }

  &:nth-child(2):before {
    background-color: #ccedd1;
  }

  &:nth-child(3):before {
    background-color: #fd9595;
  }

  ${p => p.color && `:before {
      background-color: ${p.color} !important;
    }
  `}
`;

export const ExtraDetails = {};

ExtraDetails.Block = styled.div`
  padding: 32px 0 48px 32px;
  background: #FFFFFF;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08), 0px 10px 16px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  position: absolute;
  right: -8px;
  top: -12px;
  bottom: -12px;
  width: 39%;
  display: flex;
  column-gap: 19px;

  ${p => p.centered && `
    top: 50%;
    bottom: auto;
    transform: translateY(-50%);
    height: 256px;
  `}
  
  &:before {
    display: block;
    content: '';
    width: 30px;
    height: 30px;
    padding: 15px;
    background: #FD9595;
    border-radius: 50%;
  }

  ${p => p.color && `:before {
    background-color: ${p.color};
  }
`}
`;

ExtraDetails.Title = styled.h3`
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
  margin-bottom: 8px;
  padding-right: 32px
`;

ExtraDetails.ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

ExtraDetails.List = styled.ul`
  padding-left: 20px;
  padding-right: 32px;
  overflow-y: auto;
  max-height: 100%;
  margin-bottom: 0;

  &::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-thumb {
    height: 50xp;
    background: rgba(127, 127, 127, 0.65);
    border-radius: 100px;
  }
`;

ExtraDetails.ListItem = styled.li`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  list-style-type: decimal;
`;

export const ChartAxisLabel = styled.h4`
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  text-align: center;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 8px;

  ${p => p.rotated && `
    transform: rotate(-90deg);
    position: absolute;
    top: 50%;
    left: -10px;
    margin: 0;
  `}
`;

export const Charts = {};

Charts.Wrapper = styled.div`
  background: #fff;
  margin-top: 20px;
  width: 100%;
  position: relative;
  z-index: 1;

  ${p =>
    p.setMaxHeight &&
    `
    max-height: 450px;
  `}
`;

Charts.Teams = {};

Charts.Teams.Wrapper = styled.div`
  display: flex;
  margin-bottom: 35px;
  color: #36507e;
  font-weight: 600;
  font-size: 15px;
  gap: 60px;
`;

Charts.Teams.Row = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  ${p =>
    p.margin &&
    `
    margin: ${p.margin};
  `}
`;

Charts.Teams.TeamColor = styled.div`
  height: 16px;
  width: 64px;
  margin-right: 8px;

  ${p =>
    p.background &&
    `
    background: ${p.background};
  `}
`;

Charts.Teams.TeamName = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
`;

Charts.Chart = styled.div`
  width: 100%;
`;

export const Assessments = {};

Assessments.Legends = styled.div`
  display: flex;
  gap: 30px;
  margin-top: 10px;
  align-items: center;
  justify-content: center;
`;

Assessments.Legend = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.38);

  &:before {
    display: block;
    content: '';
    width: 15px;
    height: 5px;
    background: #52C5CD;
    margin-right: 15px;
  }

  &:nth-child(2):before {
    background: rgba(0, 27, 59, 0.6);
  }
`;

Assessments.Marks = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 7px;
  margin-bottom: 35px;
  align-items: center;
  justify-content: center;
`;

Assessments.Mark = styled.div`
  font-size: 14px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.38);
  font-weight: 700;
`;

export const UserAnswer = {};

UserAnswer.Item = styled.div`
  display: flex;
  margin-bottom: 12px;
`;

UserAnswer.Profile = styled.div`
  width: 85px;
  margin-right: 7px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

UserAnswer.AvatarWrapper = styled.div`
  width: 49px;
  height: 49px;
  background: #fff;
  margin-bottom: 8px;
  border-radius: 50%;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }
`;

UserAnswer.Username = styled.p`
  white-space: nowrap;
  color: rgba(0, 27, 59, 0.6);
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
`;

UserAnswer.Text = styled.div`
  border: 1px solid #CCCCCC;
  padding: 16px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.9);
  width: calc(100% - 100px);
  background: #fff;
  position: relative;

  &:before {
    content: '';
    display: inline-block;
    background: url(${TriangleWhite}) no-repeat center center;
    background-size: 12.5px 20px;
    width: 12.5px;
    height: 20px;
    position: absolute;
    right: 100%;
    top: 16px;
  }

  ${UserAnswer.Item}:nth-child(2n-1) & {
    background: rgba(249, 193, 81, 0.5);

    &:before {
      background-image: url(${TriangleYellow});
    }
  }
`;


// WEBPACK FOOTER //
// ./src/instructor/components/peer-feedback/components/ui.js